// MEMORY MANAGEMENT
/**
 * Destroy all objects attributes to free memory of browser
 * @param {*} object
 */

export function destroyObjectAttributes(object) {
  try {
    if (object) {
      const properties = Object.getOwnPropertyNames(object);
      // Mettre chaque propriété à null
      for (const prop of properties) {
        object[prop] = null;
      }
    }
  } catch (e) {
    console.log("Catch destroyObjectAttribute:", e);
  }
}
